import * as React from 'react';
import { Container, Row, Col, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { stat } from 'fs';
import 'react-notifications-component/dist/theme.css';
import CommunityUser from "./communityUser";
import UserDetail from "./userDetail";
import CommunityGrowth from "./communityGrowth";
import MessageBoardEngagement from "./messageBoardEngagement";
import ChannelEngegement from "./channelEngagement";
import { showAlert } from '../common/functions';

class DashBoardPageComponent extends React.Component {
	state = {
		page: "",
		id: -1,
		title: ""
	}
	constructor(props: any) {
		super(props);
		this.state = {
			page: "",
			id: -1,
			title: ""
		}
		this.handleCallBackMethod = this.handleCallBackMethod.bind(this);
	}

	componentDidMount() {
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var pageValue = (id >= 0) ? "userdetail" : "";
		this.setState({
			...stat,
			page: pageValue,
			id: id
		});

		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}
		document.title = `${id>0? "Community User":"User Management"} - Daily Audio Bible Administration`;
	}

	handleCallBackMethod(value) {
		this.setState({ title: value });
	}

	render() {		
		return (
			<div className="dashboard-page">
				<Container>
					{this.state.page === "userdetail" && (
						<Row>
							<Col lg="12">
								<UserDetail callback={this.handleCallBackMethod} id={this.state.id} />
							</Col>
						</Row>
					)}
					{(new URLSearchParams(window.location.search)).get("id") === null && (
						<>
							<Row>
								<Col lg="12">
									<div className="about-container">
										<h2>
											<span data-testid="h2Text">Daily Audio Bible Community Management</span>
										</h2>
									</div>
									<CommunityUser key="communityuser" showSearch={true} title="Find a Community Member" />
								</Col>
							</Row>
							<Row className="map-container">
								<Col lg="6" className="mc-map">
									<CommunityGrowth />
								</Col>
								<Col lg="6" className="mc-map">
									<ChannelEngegement userId={this.state.id} />
								</Col>
							</Row>
							<Row className="map-container">
								<MessageBoardEngagement userId={this.state.id} />
							</Row>							
						</>
					)}
				</Container>
			</div>
		);
	}
}

export default DashBoardPageComponent;